import { cn } from '@cibli/shared';
import { useTranslation } from 'react-i18next';

interface Step {
  label: string;
}

interface Props {
  currentStep: number;
  steps: Step[];
}

export default function CVStatusBar({ currentStep, steps }: Props) {
  const { t } = useTranslation();
  return (
    <nav
      aria-label={t('CV.statusBarAria')}
      className="flex items-center justify-center gap-2 sm:gap-3 py-4"
    >
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isPast = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;
        const isFuture = stepNumber > currentStep;

        return (
          <div key={step.label} className="flex items-center">
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  'flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold transition-colors',
                  isPast && 'bg-[#21c294]/20 text-[#009f7f]',
                  isCurrent && 'bg-[#21c294] text-white',
                  isFuture && 'bg-gray-200 text-gray-400',
                )}
              >
                {isPast ? '✓' : stepNumber}
              </span>
              <span
                className={cn(
                  'text-sm font-semibold',
                  isCurrent && 'text-[#254441]',
                  isPast && 'text-[#009f7f]',
                  isFuture && 'text-gray-400',
                )}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={cn('mx-2 h-0.5 w-6 sm:w-10', isPast ? 'bg-[#21c294]' : 'bg-gray-200')}
              />
            )}
          </div>
        );
      })}
    </nav>
  );
}
